module.exports = __webpack_public_path__ + "static/media/angular.64a3fd75.svg";